import React, { useState } from "react";
import { CustomerViewDetailsViewPrimaryInfoProps } from "./customer-view-details-view-primary-info.props";
import AvatarIcon from "../../../../../../assets/icons/avatar.svg";
import "./customer-view-details-view-primary-info.scss";
import ProfileImageUploadComponent from "../../../../../../common/components/edit-upload-image/ProfileImageUploadComponent";
import PhoneIcon from "../../../../../../assets/icons/phone.svg";
import MailIcon from "../../../../../../assets/icons/mail.svg";
import SMSIcon from "../../../../../../assets/icons/sms.svg";
import ContactLink from "../../../../../../common/components/contact-link/contact-link";
import { useLogin } from "../../../../../../common/hooks/useUser";
import SendSmsPopup from "../../../../../send-sms-popup/send-sms-popup";
import {
  customerLinkActivityLog,
  sendCustomerSMSAndActivityLog,
} from "../../../../../../api/customer";

const CustomerViewDetailsViewPrimaryInfo: React.FC<
  CustomerViewDetailsViewPrimaryInfoProps
> = (props: any) => {
  const {
    customerDetails,
    viewPrimaryInfoOpen,
    setViewPrimaryInfoOpen,
    viewFullInfoOpen,
    uploadedImage,
    setUploadedImage,
    setUploadedImageFile,
    setRemoveImage,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
  } = props;
  const handleEditOpen = () => setViewPrimaryInfoOpen(!viewPrimaryInfoOpen);
  const [isImageRemoved, setIsImageRemoved] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);
  const { tenantDetails, loginDetails } = useLogin();
  const isTwilioConfigured = loginDetails?.isTwilioConfigured;
  const [sendSmsPopupOpen, setSendSmsPopupOpen] = useState(false);

  const checkDisableField = () => {
    return tenantDetails?.tenantType === "SuperTenant" &&
      customerDetails?.assigned_to
      ? true
      : false;
  };

  const handleProfileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 10) {
        setUploadError("File size should not exceed 10MB");
        return;
      }
      setUploadedImageFile(file);
      setIsImageRemoved(false);
      setUploadedImage(URL.createObjectURL(file));
      setUploadError(null);
    }
  };
  const handleRemoveImage = () => {
    setUploadedImage(null);
    setUploadedImageFile(null);
    setIsImageRemoved(true); // triggers fallback to placeholder image
    setRemoveImage(true);
  };
  const sendCustomerSMS = async (data: { message: string }) => {
    try {
      const { message } = data;
      const res = await sendCustomerSMSAndActivityLog(customerDetails?.id, {
        message,
        contactType: "SMS",
        contactValue: customerDetails?.primary_phone_number,
      });
      if (res.data.success) {
        setAlertMessage("SMS sent successfully");
        setAlertType("success");
        setAlertOpen(true);
      }
    } catch (error) {
      console.error(error);
      if (setAlertMessage && setAlertType && setAlertOpen) {
        setAlertMessage("Failed to send SMS");
        setAlertType("error");
        setAlertOpen(true);
      }
    }
  };
  return (
    <>
      <div className="customer-list-view-details-view-box-primary-info">
        <div className="customer-list-view-details-view-box-primary-info-profile-edit">
          <div className="customer-list-view-details-view-box-primary-info-profile">
            <div className="customer-list-view-details-view-box-primary-info-profile-pic profile-upload-container">
              <ProfileImageUploadComponent
                imageUrl={
                  isImageRemoved
                    ? null
                    : customerDetails?.customer_profile_file_Url
                }
                uploadedImage={uploadedImage}
                onImageUpload={handleProfileUpload}
                onRemoveImage={handleRemoveImage}
                viewFullInfoOpen={viewFullInfoOpen}
                placeholderImage={AvatarIcon}
                disableEditIcon={checkDisableField()}
              />
            </div>
            <div className="customer-list-view-details-view-box-primary-info-profile-details">
              <div className="customer-list-view-details-view-box-primary-info-profile-details-name">
                {customerDetails?.first_name || ""}{" "}
                {customerDetails?.middle_name || ""}{" "}
                {customerDetails?.last_name || ""}
              </div>
              <div className="customer-list-view-details-view-box-primary-info-profile-details-contact">
                <span className="contact-item">
                  <img src={PhoneIcon} alt="Phone" className="contact-icon" />
                  {!customerDetails?.primary_phone_number ||
                  customerDetails.primary_phone_number === "null" ? (
                    "-"
                  ) : (
                    <ContactLink
                      type="Phone"
                      value={customerDetails.primary_phone_number}
                      id={customerDetails?.id}
                      isCustomer={true}
                    />
                  )}
                </span>
                <div className="contact-divider"></div>
                <span className="contact-item">
                  {isTwilioConfigured ? (
                    <img
                      src={SMSIcon}
                      alt="SMS"
                      className="sms-icon"
                      style={{ cursor: "not-allowed", opacity: 0.5 }}
                      onClick={(e) => e.preventDefault()}
                    />
                  ) : (
                    <img
                      src={SMSIcon}
                      alt="SMS"
                      className="sms-icon"
                      onClick={(e) => e.preventDefault()}
                    />
                  )}
                  {!customerDetails?.primary_phone_number ||
                  customerDetails.primary_phone_number === "null" ? (
                    "-"
                  ) : (
                    <ContactLink
                      type="SMS"
                      value={customerDetails.primary_phone_number}
                      id={customerDetails?.id}
                      setSendSmsPopupOpen={setSendSmsPopupOpen}
                    />
                  )}
                </span>
                <div className="contact-divider"></div>
                <span className="contact-item">
                  <img
                    src={MailIcon}
                    alt="Mail"
                    className="contact-icon mail-icon"
                  />
                  <ContactLink
                    type="Email"
                    value={customerDetails?.primary_email_address || "-"}
                    id={customerDetails?.id}
                    isCustomer={true}
                  />
                </span>
              </div>
            </div>
          </div>
          {/* {!viewPrimaryInfoOpen ? (
          <div className="customer-list-view-details-view-box-primary-info-edit">
            <button
              className="customer-list-view-edit-section"
              onClick={handleEditOpen}
            >
              Edit
            </button>
          </div>
        ) : (
          ""
        )} */}
        </div>
        {uploadError && <div className="error-message">{uploadError}</div>}
      </div>
      {sendSmsPopupOpen && (
        <SendSmsPopup
          setSendSmsPopupOpen={setSendSmsPopupOpen}
          onSuccess={sendCustomerSMS}
        />
      )}
    </>
  );
};

export default CustomerViewDetailsViewPrimaryInfo;
